import React from 'react'
import {  useState } from "react";
import { useNavigate } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { usePostBrandMutation } from '../../../../store/api/barand_master'; 
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
function Brand() {
  const navigate = useNavigate()
  const [tab, settab] = useState(1)
  const [res, setRes] = useState(false)
  const [brand, setBrand] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const [postBrand] = usePostBrandMutation();
  const[status,setStatus] = useState(false)

  const handleSubmit = async () => {
    if (!brand.trim()) {
      setError('Please enter a brand name');
      setptype('Error');
      setShowError(true);
      return; 
    }
    const payload = { brand, description };
    try {
      const res = await postBrand(payload).unwrap();
      if (res) {
        setStatus()
      }
      setError('Brand created successfully!');
      setptype('Success');
      setShowError(true);
      setBrand('');
      setStatus(true)
      setTimeout(() => {
        navigate('/master/brand/brand-list')
      }, 3000);
      setDescription('');
    } catch (err) {
      setError(err?.data?.message || 'Failed to create brand. Brand name may already exist.');
      setptype('Error');
      setShowError(true);
    }
  };
  return (
    <>
      <FormLayout
        title="New Brand"
        breadcrumbs={[
          { label: "Brand" },
          { label: "Brand List", url: "/master/brand/brand-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
            <Button
              className="custom-btn-bluecolor d-flex"
              iconName="BiCloudUpload"
              style={{ gap: '2px' }}
              iconSize={14}
            >
              Upload
            </Button>
            <Button
              className="createbtn d-flex"
              style={{ gap: '2px', height: '28px' }}
              iconName="GrCopy"
              iconSize={12}
            >
              Duplicate
            </Button>
            <Button
              className="custom-btn-00989"
              iconName="LuFilePlus2"
              style={{ gap: '2px', height: '28px' }}
              onClick={handleSubmit}
              iconSize={12}
            >save
            </Button>
            <Button
              to="/brand/create-brand"
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff",flexGrow:'1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
              <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                <span style={{ position: 'relative', top: '-1px' }}>
                  <GetIcon iconName="CgAttachment" size={12} />
                </span>
                <span className=" fw-semibold" style={{ color: "#391F84" }}>
                  Attachments
                </span>
              </div>
            </div>
          </div>
          <div className="mt-2 py-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" ,flexGrow:'1'}}>
            <div className="row d-flex justify-content-between">
              <div className="col-12" >
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1 setBrand={setBrand} setDescription={setDescription} brand={brand} description={description} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayout>
    </>
  )
}

export default Brand
